import React from "react";
import "./Sidebar.scss";
import { Link } from "react-router-dom";
import logo from "../assets/diwise-uk.svg";
const Sidebar = ({ handleLogout }) => {
  const links = [
    {
      link_name: "Dashboard",
      link_path: "/",
    },
    {
      link_name: "Blogs List",
      link_path: "/bloglist",
    },
    {
      link_name: "Contacts List",
      link_path: "/contactlist",
    },
  ];

  return (
    <>
      <div class="sidebar">
        <div class="list">
          <h3>Arvind Patil Nilangekar</h3>

          <div class="links">
            {links.map((item, index) => (
              <Link to={item.link_path} key={index}>
                {item.link_name}
              </Link>
            ))}
          </div>
          <div class="btn" onClick={handleLogout}>
            logout
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
